const ExclamationMarkIcon = () => (
  <svg viewBox="0 0 22.83 22.83" xmlns="http://www.w3.org/2000/svg">
    <title>Exclamation Mark</title>
    <path d="M12.56,8H10.27V5.71h2.29Zm0,9.13H10.27V10.27h2.29ZM11.41,0A11.42,11.42,0,1,0,22.83,11.41,11.41,11.41,0,0,0,11.41,0Z" />
  </svg>
);

export default ExclamationMarkIcon;
